import {
  DEFAULT_DELIVERY_TIME_LOG_LABELS,
  DEFAULT_DELIVERY_TIME_THRESHOLDS,
  DEFAULT_EM_THRESHOLDS,
  DEFAULT_INTRAPARTUM_THRESHOLDS,
  DEFAULT_TIME_LOG_FIELD_LABELS,
  DeliveryTimeLogFieldKey,
  DeliveryTimeThreshold,
  EmThreshold,
  IntrapartumThreshold,
  SETTINGS,
  TIME_LOG_CONFIG,
  TimeLogConfig,
  TimeLogFieldKey,
} from '@hb/shared'
import { useMemo } from 'react'
import { useDocument } from '../../../backend/db/hooks'

export const useTimeLogConfig = (): {
  fieldLabels: Record<TimeLogFieldKey, string>
  emThresholds: EmThreshold[]
  intrapartumThresholds: IntrapartumThreshold[]
  deliveryTimeThresholds: DeliveryTimeThreshold[]
  deliveryTimeLogLabels: Record<DeliveryTimeLogFieldKey, string>
} => {
  const { data } = useDocument<TimeLogConfig>(SETTINGS, TIME_LOG_CONFIG)

  const fieldLabels = useMemo<Record<TimeLogFieldKey, string>>(
    () => ({ ...DEFAULT_TIME_LOG_FIELD_LABELS, ...data?.fieldLabels }),
    [data],
  )

  const emThresholds = useMemo<EmThreshold[]>(
    () => data?.emThresholds ?? DEFAULT_EM_THRESHOLDS,
    [data],
  )

  const intrapartumThresholds = useMemo<IntrapartumThreshold[]>(
    () => data?.intrapartumThresholds ?? DEFAULT_INTRAPARTUM_THRESHOLDS,
    [data],
  )

  const deliveryTimeThresholds = useMemo<DeliveryTimeThreshold[]>(
    () => data?.deliveryTimeThresholds ?? DEFAULT_DELIVERY_TIME_THRESHOLDS,
    [data],
  )

  const deliveryTimeLogLabels = useMemo<Record<DeliveryTimeLogFieldKey, string>>(
    () => ({ ...DEFAULT_DELIVERY_TIME_LOG_LABELS, ...data?.deliveryTimeLogLabels }),
    [data],
  )

  return {
    fieldLabels,
    emThresholds,
    intrapartumThresholds,
    deliveryTimeThresholds,
    deliveryTimeLogLabels,
  }
}
